import { render, staticRenderFns } from "./GoogleMatch.vue?vue&type=template&id=e8c8ce70&"
import script from "./GoogleMatch.vue?vue&type=script&lang=js&"
export * from "./GoogleMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports